export const projects = [
    {
      id: 1,
      title: "משרדים | בניין ברנדס",
      date: "2025",
      location: "קרית אתא",
      coverImage: "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361430/IMG_3360_vshz0d.jpg", 
      excerpt:
       "בבניין משרדים בין שתי קומות המאכלס מגוון רחב של עסקים היינו אחראים על חלוקות הפנים, דלתות הפנים בוצעו באמצעות משקוף סיריון, המאפשרות יצירת משרדים סגורים, ברורים ושימושיים לסוחרים השונים.",
      summary:
        "בדלתות הכניסה לכל מתחם נבחרה דלת עם משאבת רצפה, פתרון המתאים במיוחד לאזורים בעלי תנועה אינטנסיבית שנכנסים ויוצאים.",
      features: ["זכוכית מחוסמת", "מעקה מדרגות", "דלתות זכוכית"],
      images: ["https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361469/IMG_4567_pwubhu.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361466/IMG_3720_pqf7wt.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361464/IMG_3777_mpm3kc.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361463/IMG_2956_zbux0m.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361459/IMG_4280_cry9f7.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361457/IMG_4297_geshlq.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361454/IMG_4568_pctb1c.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361451/IMG_8964_l9qsyh.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361449/IMG_2191_smaita.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361446/IMG_8100_fbufyi.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361444/IMG_8119_kylqob.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361441/IMG_8097_zpj7da.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361439/IMG_6028_y3asqv.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361436/IMG_8104_ejvmz0.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361434/IMG_9368_dl7ju2.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361432/IMG_8133_vrf5az.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361430/IMG_3360_vshz0d.jpg",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361426/IMG_4365_beofhj.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361424/IMG_3380_rkyeoa.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361421/IMG_2196_cyj5ml.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361419/IMG_4310_icijza.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361417/IMG_9385_wyahzj.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361415/IMG_6779_qpv0vw.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361414/IMG_9032_hqgmhx.heic",
        "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769361412/IMG_6774_kgvhdr.heic",


      ],
      videos: [],
    },
    {
      id: 2,
      title: "ווילה בבוסתן",
      date: "2025",
      location: "בוסתן הגליל",
      coverImage: "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145552/IMG_5626_iwwmtz.heic",
      excerpt:
        "בווילה רחבת היקף זו בוצעו כלל המקלחונים מזכוכית אקסטרה קליר בעובי 10 מ״מ, בחירה זו נעשתה בעקבות הגובה החריג של המקלחונים לקבלת מקלחון יציב , איכותי ויוקרתי.",
      summary:
        "בחדר השינה הותקנו שתי דלתות מזכוכית אסיד קליר אטומה המאפשרת שמירה על הפרטיות לצד חדירת אור ושמירה על שפה מודרנית ונקייה.",
      features: ["ויטרינות", "מראות", "פרזול איכותי"],
      images: ["https://res.cloudinary.com/dvmyddd9z/image/upload/v1769362638/IMG_4219_yzux8a.heic",
         "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769362635/IMG_0674_p6lltn.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769362632/IMG_0669_uxj4r1.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769362629/IMG_4239_rrvfa8.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769362627/IMG_4229_mpcvpz.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769362623/IMG_4240_otsqms.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769362620/IMG_9311_cdlss9.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769362617/IMG_9326_rwxfmo.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769362614/IMG_0194_gyusxp.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769362612/IMG_9251_mcalno.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145548/IMG_5630_bnkhqf.heic"

        ],
      videos: [],
    },
  
    {
      id: 3,
      title: "ווילה בזכרון",
      date: "2025",
      location: "זכרון יעקב",
      coverImage: "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769363470/IMG_2462_ld1vri.heic",
      excerpt:
        "בפרוייקט זה בוצעו מקלחוני רצפה -  תקרה מזכוכית בעובי 10 מ״מ כחלק מתפיסה תכנונית ששמה דגש על נוכחות ומראה מינימליסטי.",
      summary:
        "הבחירה בזכוכית עבה זו אפשרה יצירת מקלחונים גבוהים ועמידים, מה שיצר חלל שמרגיש גמו מלון בוטיק מפנק.",
      features: ["ויטרינות", "מראות", "פרזול איכותי"],
      images: ["https://res.cloudinary.com/dvmyddd9z/image/upload/v1769363470/IMG_2462_ld1vri.heic",
         "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769363461/IMG_2420_bm1bpu.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769363458/IMG_2470_alkz4w.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769363454/IMG_2410_fcgmsj.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769363451/IMG_2405_ej6tcw.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769363448/IMG_2396_j8mcde.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769363444/IMG_3348_t0zs6i.jpg",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769363443/IMG_2392_lqfbtl.heic"
          
        ],
      videos: [],
    },
    {
      id: 4,
      title: "סופר ג׳יפ",
      date: "2025",
      location: "חיפה",
      coverImage: "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424264/IMG_1816_t2xjba.heic",
      excerpt:
        "חזית חלל התצוגה נסגרה באמצעות וויטרינות זכוכית היקפית היוצרת מעטפת שקופה ורציפה סביב חלל הרכב.",
      summary:
        "הבחירה בזכוכית בעובי 12 מ״מ הופכת את קיר הזכוכית לאלמנט מבני יציב וחזק.",
      features: ["ויטרינות", "מראות", "פרזול איכותי"],
      images: ["https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424264/IMG_1816_t2xjba.heic",
         "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424251/IMG_1993_vygbaz.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424247/IMG_1995_csqpx3.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424246/IMG_1998_enumsd.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424243/IMG_1990_u1aa73.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424236/IMG_1794_jkv4fq.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424233/IMG_1822_ee0krr.heic"
         
         
        ],
      videos: [],
    },

    {
      id: 5,
      title: "משרדי אלדרוטק ",
      date: "2025",
      location: "קריות",
      coverImage: "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424609/IMG_8271_c1fhne.heic",
      excerpt:
        "בפרוייקט זה ביצענו חלוקה פנימית של משרדי החברה באמצעות מחיצות ודלתות זכוכית , ויצרנו חללי עבודה מוגדרים ושקופים.",
      summary:
        "הדלתות בוצעו עם משקוף סיריון נמאפשר סגירה הרמטית ושמירה על הפרטיות ואקוסטיקה. בחדר הישיבות נבחרה מערכת דלת הזזה חשמלית המאפשרת גמישות תפעולית , פתיחה מלאה של החלל בעת הצורך וסגירה מהירה ליצירת חדר פרטי.",
      features: ["ויטרינות", "מראות", "פרזול איכותי"],
      images: ["https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424609/IMG_8271_c1fhne.heic",
         "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424602/IMG_8323_s6vr3u.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424597/IMG_8276_luxlxu.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424593/IMG_8267_dpy7kn.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424590/IMG_8311_lagupz.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424585/IMG_8274_qknqim.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424580/IMG_8294_b4hcit.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424576/IMG_8283_mciebb.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1769424573/IMG_8332_utkqsj.heic"
         
         
        ],
      videos: [],
    },
    {
      id: 6,
      title: "ווילה בגבעת טל",
      date: "2023",
      location: "קריית אתא",
      coverImage: "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773144138/IMG_5654_rektc0.heic",
      features: ["ויטרינות", "מראות", "פרזול איכותי"],
      images: ["https://res.cloudinary.com/dvmyddd9z/image/upload/v1773144145/IMG_5226_ibdxbl.heic",
         "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773144138/IMG_5654_rektc0.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773144141/IMG_5203_cejo1g.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773144141/IMG_5729_xffhtt.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773144140/IMG_5211_i9umir.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773144138/IMG_5653_peukvy.heic"
      
         
         
        ],
      videos: [],
    },
    {
      id: 7,
      title: "משרדי קופל",
      date: "2024",
      location: "חיפה",
      coverImage: "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145930/IMG_6721_nulacy.heic",
      excerpt:
        "חללי המשרד הוגדרו באמצעות מחיצות ודלתות זכוכית, הדלתות הותקנו עם מנגנון משאבת רצפה נסתר, המאפשר תנועה חלה וסגירה איטית ומבוקרת.",
      features: ["ויטרינות", "מראות", "פרזול איכותי"],
      images: ["https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145944/IMG_6730_heyfjq.heic",
         "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145941/IMG_8337_d2ud9e.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145939/IMG_5439_zpnpfr.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145931/IMG_6725_ojl7lj.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145937/IMG_8082_d5l8sv.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145935/IMG_5440_bcc0yy.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145934/IMG_6317_f3ierv.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145932/IMG_8387_bpbot9.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145929/IMG_6340_n7eih3.heic",
          "https://res.cloudinary.com/dvmyddd9z/image/upload/v1773145928/IMG_8384_yeqmib.heic"      
         
        ],
      videos: [],
    },

  ];
  